module.exports = __webpack_public_path__ + "img/2.3546748e.jpg";